import React, { Fragment } from 'react';
import styled from 'styled-components';

import PropTypes from 'prop-types';
import Styles from './TicketInfo.styles';
import change from '../TicketsWhite/Assets/ico_change_purple.svg';
import singleDestinationToggle from '../../../assets/images/icons/CBX_Ico_Change_Single.png';
import Text from '../../base/Text';
import OptionsInput from '../../base/OptionsInputFlat';
import ValidateButton from '../TicketsWhite/ValidateButton';
import userIcon from '../../../assets/images/icons/CBX_purplePerson.svg';
import calendarIcon from '../../../assets/images/icons/CBX_purpleCalendar.svg';
import locationIcon from '../../../assets/images/icons/CBX_purpleUbication.svg';
import shuttlePurpleIcon from '../../../assets/images/icons/CBX_purpleShuttle.svg';
import SelectRadioButton from '../../base/SelectRadioButton/SelectRadioButton';
import { capitalize } from '../../../helpers';

const MainWrapper = styled.div`${Styles.mainWrapper}`;
const DestinationWrapper = styled.div`${Styles.destinationWrapper}`;
const Column = styled.div`${Styles.column}`;
const Row = styled.div`${Styles.row}`;
const RowOriginDestination = styled.div`${Styles.rowOriginDestination}`;
const PlaceWrapper = styled.div`${Styles.placeWrapper}`;
const PlaceCode = styled(Text).attrs({ bold: true })`${Styles.placeCode}`;
const PlaceStr = styled(Text).attrs({ bold: true })`${Styles.placeStr}`;
const TogglePlaces = styled.img`${Styles.togglePlaces}`;
const Select = styled.select`${Styles.inputRounderSelect}`;
const InputsWrapper = styled.div`${Styles.inputsWrapper};`;
const LabelInput = styled(Text).attrs({ bold: true })`${Styles.labelInput}`;
const PlaceLabel = styled(Text).attrs({ bold: true })`${Styles.placeLabel}`;
const ParkingWrapper = styled.div`${Styles.parkingWrapper}`;
const Info = styled(Text).attrs({ bold: true, tag: 'h4' })`${Styles.info}`; // prettier-ignore
const AddPlacesContainer = styled.div`${Styles.addPlacesContainer}`;
const RounderComponent = styled.div`${Styles.rounderComponent}`;
const Increment = styled.div`${Styles.increment}`;
const Decrement = styled.div`${Styles.increment}`;
const ShuttleIcon = styled.img`${Styles.shuttleIcon}`;

/**
* TicketInfo component
* @returns {JSX.Element}
*/
const TicketInfo = ({
  ticketType,
  travelPurposes,
  shuttleDestinations,
  shuttleOrigins,
  quantityPersons,
  hasBlackTheme,
  isSorting,
  name,
  translations,
  activeTicketType,
  ticketNumber,
  activeTravelType,
  flightDate,
  returnDate,
  minDate,
  maxDate,
  ticketTypeHandler,
  buyingToggle,
  travelTypeHandler,
  travelPurposeHandler,
  shuttleDestinationHandler,
  travelPurpose,
  flightDateHandler,
  returnDateHandler,
  switchPlaces,
  origin,
  locale,
  destination,
  confirmAction,
  selectorItem,
  startDate,
  startTime,
  endDate,
  endTime,
  startTimeHandler,
  endTimeHanlder,
  endDateHandler,
  startDateHandler,
  onBundleSelect,
  selectedBundle,
  callParkingApi,
  getParkingPrice,
  isCallingParkingApi,
  lot,
  price,
  incrementShuttle,
  decrementShuttle,
  shuttleDestination,
  shuttleOrigin,
  shuttleStartDate,
  shuttleEndDate,
  shuttlePassengers,
  shuttleTravelType,
  shuttleEndDateHandler,
  shuttlStartDateHandler,
  shuttleTravelTypeHandler,
  shuttleOriginHandler,
  isCallingShuttleApi,
  changeTravelType,
  page
}) => {
  /**
   * createTimeArray
   * @returns {array} Array of valid times
   * @param {number} step - Step in minutes for array creation
   * @returns {[]} - Array containing day hours in defined step minutes
   */
  const createTimesArray = (step) => {
    const d = new Date(1970, 0, 1);
    const t = [];
    while (d.getDate() === 1) {
      const v = d.toTimeString().slice(0, 5);
      t.push({ name: v, value: v });
      d.setMinutes(d.getMinutes() + step);
    }
    return t;
  };

  /**
   * createTimeArray
   * @returns {array} Array of valid times
   * @param {number} step - Step in minutes for array creation
   * @returns {[]} - Array containing day hours in defined step minutes
   */
  const createTimesArrayWheels = (step) => {
    const d = new Date(1970, 0, 1, 9, 0);
    const t = [];
    while (d.getDate() === 1) {
      const v = d.toTimeString().slice(0, 5);
      t.push({ name: v, value: v });
      d.setMinutes(d.getMinutes() + step);
    }
    return t;
  };
  const timeStep = 30;

  /**
   * getStartTimeOptions
   * @returns {[]} - Array containing start time options
   */
  const getStartTimeOptions = () => {
    const d = new Date();
    const h = d.getHours();
    const m = d.getMinutes();
    const t = createTimesArray(timeStep);
    const filtered = t.filter((o) => {
      const optH = parseInt(o.value.split(':')[0], 10);
      const optM = parseInt(o.value.split(':')[1], 10);
      return (m < timeStep ? optH >= h + 6 : optH > h + 6) && (m < timeStep && h === optH ? optM === timeStep : 1);
    });
    return new Date(`${startDate}T00:00:00.000`).getTime() > Date.now() ? createTimesArray(timeStep) : filtered;
  };

  const getStartTimeOptionsWheels = () => {
    const d = new Date();
    const h = d.getHours();
    const m = d.getMinutes();
    const t = createTimesArrayWheels(timeStep);
    const filtered = t.filter((o) => {
      const optH = parseInt(o.value.split(':')[0], 10);
      const optM = parseInt(o.value.split(':')[1], 10);
      return (m < timeStep ? optH >= h : optH > h) && (m < timeStep && h === optH ? optM === timeStep : 1);
    });
    return new Date(`${startDate}T00:00:00.000`).getTime() > Date.now() ? createTimesArrayWheels(timeStep) : filtered;
  };

  /**
   * getEndTimeOptions
   * @returns {[]} - Array containing end time options
   */
  const getEndTimeOptions = () => {
    const d = new Date(`${startDate}T${startTime}:00.000`);
    const startH = parseInt(startTime.split(':')[0], 10);
    const startM = parseInt(startTime.split(':')[1], 10);
    const t = [...getStartTimeOptions()].splice(-(getStartTimeOptions().length - 1));
    const filtered = t.filter((o) => {
      const optH = parseInt(o.value.split(':')[0], 10);
      const optM = parseInt(o.value.split(':')[1], 10);
      return (startM < timeStep ? optH >= startH : optH > startH) && (startM < timeStep && startH === optH ? optM === timeStep : 1);
    });
    return new Date(`${endDate}T00:00:00.000`).getTime() > d.getTime() ? createTimesArray(timeStep) : filtered;
  };

  if (callParkingApi && lot) {
    getParkingPrice(lot);
  }

  const bundles = [
    {
      //id: '13db92e5-99e1-4183-8405-ba311c5d116a',
      id: '64f63031-147e-4edd-a157-851c310f7045',
      image: 'https://cignuz-strapi-cms.s3.amazonaws.com/042c09e64f374f52a531680dc1eb0d00.jpg',
      title: translations.tickPlusShuttle
    }
  ];

  // eslint-disable-next-line require-jsdoc
  const getBundle = id => bundles.filter((bundle) => (bundle.id === id))[0];

  // eslint-disable-next-line require-jsdoc
  const selectBundle = (id) => {
    // eslint-disable-next-line no-use-before-define
    onBundleSelect(getBundle(id));
  };

  const currentFlow = typeof window !== 'undefined' ? window.localStorage.getItem('currentFlow') : null;
  const isBundle = currentFlow === 'Bundles' && page === 'configTicket';
  if (isBundle && activeTravelType === 'roundtrip') {
    travelTypeHandler({
      target: {
        value: 'oneway'
      }
    });
  }
  if (isBundle && origin.abbreviatedPlace.toUpperCase() !== 'TJX') {
    switchPlaces();
  }
  if (isBundle && activeTicketType !== 1) {
    ticketTypeHandler({
      target:{
        value: 1
      }
    });
  }
  if (isBundle && ticketNumber !== 1){
    buyingToggle({
      preventDefault: () => {},
      target: {
        value: 1
      }
    });
  }
  console.log(currentFlow, isBundle);
  console.log(ticketType);
  return (
    <Fragment>
      <MainWrapper style={{ width: '85%', display: 'contents' }}>
        {selectorItem == 'Ticket' && (
          <DestinationWrapper style={{ padding: '20px 0px 0px' }}>
            <Column style={{ flex: 3, margin: 0 }}>
              <RowOriginDestination onClick={() => {
                if (!isBundle) {
                  switchPlaces();
                }
              }}>
                <InputsWrapper>
                  <PlaceWrapper style={{ backgroundColor: '#F060A3', borderColor: '#F060A3' }}>
                    <PlaceCode style={{ color: 'white' }}>{origin.place.toUpperCase()}</PlaceCode>
                    <PlaceStr style={{ color: 'white' }}>{origin.abbreviatedPlace.toUpperCase()}</PlaceStr>
                  </PlaceWrapper>
                  <PlaceLabel style={{ fontSize: '.9rem', textAlign: 'center' }}>{translations.originLabel}</PlaceLabel>
                </InputsWrapper>
                <TogglePlaces src={activeTravelType === 'roundtrip' ? change : singleDestinationToggle} />
                <InputsWrapper>
                  <PlaceWrapper style={{ borderColor: '#D8D8D8' }}>
                    <PlaceCode>{destination.place.toUpperCase()}</PlaceCode>
                    <PlaceStr>{destination.abbreviatedPlace.toUpperCase()}</PlaceStr>
                  </PlaceWrapper>
                  <PlaceLabel style={{ fontSize: '.9rem', textAlign: 'center' }}>{translations.destinationLabel}</PlaceLabel>
                </InputsWrapper>
              </RowOriginDestination>
            </Column>
            <Column style={{ flex: 9 }}>
              <Row style={{ justifyContent: 'flex-start' }}>
                <InputsWrapper style={{ flex: 2.5 }}>
                  <Select
                    onChange={ticketTypeHandler}
                    value={activeTicketType}
                    hasBlackTheme={hasBlackTheme}
                    isSorting={isSorting}
                  >
                    {ticketType && ticketType.options && ticketType.options.filter((type)=>(!isBundle || type.value === 1)).map(option => (
                      <option value={option.value} key={`inputValue${name}${option.value}`}>
                        {option.name}
                      </option>
                    ))}
                  </Select>
                  <LabelInput>{translations.shoppingLabels.detail}</LabelInput>
                </InputsWrapper>
                <InputsWrapper style={{ flex: 1 }}>
                  <Select
                    onChange={buyingToggle}
                    value={ticketNumber}
                    hasBlackTheme={hasBlackTheme}
                    isSorting={isSorting}
                  >
                    {quantityPersons && quantityPersons.filter((person)=>(!isBundle ||person.value === 1)).map(option => (
                      <option value={option.value} key={`inputValue${name}${option.value}`}>
                        {option.name}
                      </option>
                    ))}
                  </Select>
                  <LabelInput>{translations.shoppingLabels.passengers}</LabelInput>
                </InputsWrapper>
                <InputsWrapper style={{ flex: 2 }}>
                  <Select
                    onChange={travelTypeHandler}
                    value={activeTravelType}
                    hasBlackTheme={hasBlackTheme}
                    isSorting={isSorting}
                  >
                    <option value="oneway">{translations.shoppingLabels.oneway}</option>
                    {!isBundle && <option value="roundtrip" selected>{translations.shoppingLabels.roundtrip}</option>}
                  </Select>
                  <LabelInput>{translations.shoppingLabels.type}</LabelInput>
                </InputsWrapper>
                <InputsWrapper style={{ flex: 4 }}>
                  <Select
                    onChange={travelPurposeHandler}
                    value={travelPurpose}
                    hasBlackTheme={hasBlackTheme}
                    isSorting={isSorting}
                  >
                    {travelPurposes.options.map(option => (
                      <option value={option.value} key={`inputValue${name}${option.value}`}>
                        {option.name}
                      </option>
                    ))}
                  </Select>
                  <LabelInput>{translations.travelPurpose}</LabelInput>
                </InputsWrapper>
              </Row>
              <Row style={{ justifyContent: 'flex-start' }}>
                <InputsWrapper>
                  <OptionsInput
                    {...ticketType}
                    name={translations.departDate}
                    inputName="flightDate"
                    calendar
                    min={isBundle ? '2024-01-30' : minDate}
                    max={isBundle ? '2024-03-31' : maxDate}
                    value={flightDate}
                    onChange={flightDateHandler}
                  />
                  <LabelInput>{translations.departDate}</LabelInput>
                </InputsWrapper>
                {activeTravelType === 'roundtrip' && (
                  <InputsWrapper>
                    <OptionsInput
                      {...ticketType}
                      name={translations.returnDate}
                      inputName="returnDate"
                      calendar
                      min={flightDate || minDate}
                      max={maxDate}
                      value={returnDate}
                      onChange={returnDateHandler}
                    />
                    <LabelInput>{translations.returnDate}</LabelInput>
                  </InputsWrapper>)}
                <Info isPrice style={{ paddingTop: '0.33em' }}>{price.total}</Info>
                {
                  confirmAction
                  && (
                    <InputsWrapper style={{ gridColumn: 'span 2' }}>
                      <ValidateButton
                        action={confirmAction}
                        disabled={!flightDate || (activeTravelType === 'roundtrip' && !returnDate) || !travelPurpose}
                        message={translations.confirm}
                      />
                    </InputsWrapper>
                  )
                }
              </Row>
            </Column>
          </DestinationWrapper>
        )}
        {selectorItem === 'Parking' && (
          <ParkingWrapper>
            <Column style={{ flex: 9 }}>
              <Row style={{ justifyContent: 'flex-start' }}>
                <p style={{ fontSize: '18px', color: '#726C79', fontWeight: 'bold' }}>{translations.reserve_parking}</p>
              </Row>
              <Row style={{ justifyContent: 'flex-start' }}>
                <InputsWrapper>
                  <OptionsInput
                    {...ticketType}
                    name={translations.startDate}
                    calendar
                    min={minDate}
                    max={maxDate}
                    value={startDate}
                    onChange={startDateHandler}
                  />
                  <LabelInput>{translations.startDate}</LabelInput>
                </InputsWrapper>
                <InputsWrapper style={{ flex: 'auto' }}>
                  <Select onChange={startTimeHandler} value={startTime} hasBlackTheme={hasBlackTheme} isSorting={isSorting}>
                    <option value="" disabled>--:--</option>
                    {getStartTimeOptions().map(option => (
                      <option value={option.value} key={`inputValue${name}${option.value}`}>
                        {option.name}
                      </option>
                    ))}
                  </Select>
                  <LabelInput>{translations.startTime}</LabelInput>
                </InputsWrapper>
                <InputsWrapper>
                  <OptionsInput
                    {...ticketType}
                    name={translations.returnDate}
                    inputName="returnDate"
                    calendar
                    min={startDate || minDate}
                    max={maxDate}
                    value={endDate}
                    onChange={endDateHandler}
                  />
                  <LabelInput>{translations.endDate}</LabelInput>
                </InputsWrapper>
                <InputsWrapper style={{ flex: 'auto' }}>
                  <Select onChange={endTimeHanlder} value={endTime} hasBlackTheme={hasBlackTheme} isSorting={isSorting}>
                    <option value="" disabled>--:--</option>
                    {getEndTimeOptions().map(option => (
                      <option value={option.value} key={`inputValue${name}${option.value}`}>
                        {option.name}
                      </option>
                    ))}
                  </Select>
                  <LabelInput>{translations.endTime}</LabelInput>
                </InputsWrapper>
                {
                  confirmAction
                  && (
                    <InputsWrapper style={{ gridColumn: 'span 2' }}>
                      <ValidateButton
                        action={confirmAction}
                        disabled={!endTime || !startTime || !startDate || !endDate || isCallingParkingApi}
                        isLoading={isCallingParkingApi}
                        message={translations.parkingButton}
                      />
                    </InputsWrapper>
                  )
                }
              </Row>
            </Column>
          </ParkingWrapper>
        )}
        {selectorItem === 'Wheels' && (
          <ParkingWrapper>
            <Column style={{ flex: 9 }}>
              <Row style={{ justifyContent: 'flex-start' }}>
                <p style={{ fontSize: '18px', color: '#726C79', fontWeight: 'bold' }}>{translations.reserve_wheels}</p>
              </Row>
              <Row style={{ justifyContent: 'flex-start' }}>
                <InputsWrapper>
                  <OptionsInput
                    {...ticketType}
                    name={translations.startDate}
                    calendar
                    min={minDate}
                    max={maxDate}
                    value={startDate}
                    onChange={startDateHandler}
                  />
                  <LabelInput>{translations.startDate}</LabelInput>
                </InputsWrapper>
                <InputsWrapper style={{ flex: 'auto' }}>
                  <Select onChange={startTimeHandler} value={startTime} hasBlackTheme={hasBlackTheme} isSorting={isSorting}>
                    <option value="" disabled>--:--</option>
                    {getStartTimeOptionsWheels().map(option => (
                      <option value={option.value} key={`inputValue${name}${option.value}`}>
                        {option.name}
                      </option>
                    ))}
                  </Select>
                  <LabelInput>{translations.startTime}</LabelInput>
                </InputsWrapper>
                {
                  confirmAction
                  && (
                    <InputsWrapper style={{ gridColumn: 'span 2' }}>
                      <ValidateButton
                        action={confirmAction}
                        disabled={!startTime || !startDate || isCallingParkingApi}
                        isLoading={isCallingParkingApi}
                        message={translations.parkingButton}
                      />
                    </InputsWrapper>
                  )
                }
              </Row>
            </Column>
          </ParkingWrapper>
        )}
        {selectorItem === 'Shuttle' && (
          <ParkingWrapper>
            <Column style={{ flex: 9 }}>
              <Row style={{ justifyContent: 'flex-start' }}>
                <p style={{ fontSize: '18px', color: '#726C79', fontWeight: 'bold' }}>{translations.reserve_shuttle}</p>
              </Row>
              <Row style={{ flex: 6, justifyContent: 'flex-start', display: "flex" }}>
                <img alt="" width="auto" height="40px" style={{ margin: '0px 10px 0px 0px', position: 'start' }} src={shuttlePurpleIcon} />
                <Column style={{ padding: '0px 9px 0px 9px', margin: 'initial' }} >
                  <Row style={{ justifyContent: 'flex-start', width: 'auto' }} onClick={() => { shuttleTravelTypeHandler({ target: { value: 'oneway' } }) }}>
                    <SelectRadioButton id={"oneway"} isSelected={shuttleTravelType} style={{ margin: "10px" }} />
                    <LabelInput style={{ fontSize: '14px', color: '#726C79', fontWeight: 'bold', margin: '0px 5px' }}>{"One way"}</LabelInput>
                  </Row>
                </Column>
                <Column style={{ padding: '0px 9px 0px 9px', margin: 'initial' }}>
                  <Row style={{ justifyContent: 'flex-start' }} onClick={() => { shuttleTravelTypeHandler({ target: { value: 'round' } }) }}>
                    <SelectRadioButton id={"round"} isSelected={shuttleTravelType} style={{ margin: "10px" }} />
                    <LabelInput style={{ fontSize: '14px', color: '#726C79', fontWeight: 'bold', margin: '0px 5px' }}>{"Round trip"}</LabelInput>
                  </Row>
                </Column>
              </Row>
              <br></br>
              <Row>
                <ShuttleIcon src={locationIcon} />
                <InputsWrapper style={{ flex: 5 }}>
                  <LabelInput>{translations.originLabel}</LabelInput>
                  <Select
                    onChange={shuttleOriginHandler}
                    value={shuttleOrigin}
                    hasBlackTheme={hasBlackTheme}
                    isSorting={isSorting}
                  >
                    <option value="" disabled>{locale === 'es' ? "Seleccionar" : "Select"}</option>
                    {shuttleOrigins && Object.keys(shuttleOrigins.data).map((option, i) => (
                      <option value={option} key={`inputValue${i + 1}`}>
                        {capitalize(option)}
                      </option>
                    ))}
                  </Select>
                </InputsWrapper>
                <InputsWrapper style={{ flex: 5 }}>
                  <LabelInput>{translations.destinationLabel}</LabelInput>
                  <Select
                    onChange={shuttleDestinationHandler}
                    value={shuttleDestination}
                    hasBlackTheme={hasBlackTheme}
                    isSorting={isSorting}
                  >
                    <option value="" disabled>{locale === 'es' ? "Seleccionar" : "Select"}</option>
                    {shuttleDestinations && Object.keys(shuttleDestinations.data).map((option, i) => (
                      <option value={option} key={`inputValue${i + 1}`}>
                        {capitalize(option)}
                      </option>
                    ))}
                  </Select>
                </InputsWrapper>
                <ShuttleIcon src={calendarIcon} />
                <InputsWrapper style={{ flex: 5 }}>
                  <LabelInput>{translations.startDate}</LabelInput>
                  <OptionsInput
                    {...ticketType}
                    name={translations.startDate}
                    calendar
                    min={minDate}
                    max={maxDate}
                    value={shuttleStartDate}
                    onChange={shuttlStartDateHandler}
                  />
                </InputsWrapper>
                {shuttleTravelType === "round" && (
                  <InputsWrapper style={{ flex: 5 }}>
                    <LabelInput>{translations.endDate}</LabelInput>
                    <OptionsInput
                      {...ticketType}
                      name={translations.returnDate}
                      inputName="returnDate"
                      calendar
                      min={shuttleStartDate || minDate}
                      max={maxDate}
                      value={shuttleEndDate}
                      onChange={shuttleEndDateHandler}
                    />
                  </InputsWrapper>)}
                <img alt="" style={{ margin: '25px 10px', position: 'center' }} width="auto" height="25px" src={userIcon} />
                <AddPlacesContainer style={{position: 'center' }}>
                  <LabelInput>{translations.passengersLabel}</LabelInput>
                  <RounderComponent>
                    <Decrement
                    style={shuttlePassengers <= 1  ? {pointerEvents: "none", opacity:'0.5', marginLeft: '8px'} : {marginLeft: '8px'} }
                    onClick={decrementShuttle}>
                      <Info>-</Info>
                    </Decrement>
                    <h3 style={{ color: '#3F2A55', margin: '0px 5px' }} id="c">{shuttlePassengers}</h3>
                    <Increment
                      style={shuttlePassengers >= 15  ? {pointerEvents: "none", opacity:'0.5', marginLeft: '8px'} : {marginLeft: '8px'} }
                      onClick={incrementShuttle}
                    >
                      <Info style={{color: "#3F2A55"}}>+</Info>
                    </Increment>
                  </RounderComponent>
                </AddPlacesContainer>
                {
                  confirmAction
                  && (
                    <InputsWrapper style={{ gridColumn: 'span 2', marginTop: "20px" }}>
                      <ValidateButton
                        action={confirmAction}
                        disabled={!shuttleOrigin || !shuttleDestination || !shuttleStartDate || (shuttleTravelType === "round" && !shuttleEndDate)}
                        isLoading={isCallingShuttleApi}
                        message={locale === 'es' ? "Buscar" : "Search"}
                      />
                    </InputsWrapper>
                  )
                }
              </Row>
              <LabelInput style={{ marginLeft: '27px', marginTop: '-15px' }}>{translations.textShuttleQuickBook}</LabelInput>
            </Column>
          </ParkingWrapper>
        )}
        {selectorItem === 'Bundles' && (
          <ParkingWrapper>
            <Column style={{ flex: 9 }}>
              <Row style={{ justifyContent: 'flex-start' }}>
                <p style={{ fontSize: '18px', color: '#726C79', fontWeight: 'bold' }}>{locale === 'es' ? 'Selecciona tu paquete' : 'Select your bundle'}</p>
              </Row>
              <Row>
            <InputsWrapper style={{ flex: 5 }}>
              <LabelInput>{locale === 'es' ? 'Paquete' : 'Bundle'}</LabelInput>
              <Select
                onChange={(evt) => {selectBundle(evt.target.value)}}
                value={selectedBundle ? selectedBundle.id : ""}
                hasBlackTheme={hasBlackTheme}
                isSorting={isSorting}
              >
                <option value="" disabled>{locale === 'es' ? "Seleccionar paquete" : "Select bundle"}</option>
                {
                 bundles.map((option, i) => (
                  <option value={option.id} key={`inputValue${i + 1}`}>
                    {capitalize(option.title)}
                  </option>
                ))}
              </Select>
            </InputsWrapper>
            <ShuttleIcon src={calendarIcon} />
            <InputsWrapper style={{ flex: 5 }}>
              <LabelInput>{translations.startDate}</LabelInput>
              <OptionsInput
                {...ticketType}
                name={translations.startDate}
                calendar
                min="2024-01-30"
                max="2024-03-31"
                value={flightDate}
                onChange={flightDateHandler}
              />
            </InputsWrapper>
            {
              confirmAction
              && (
                <InputsWrapper style={{ gridColumn: 'span 2', marginTop: "20px" }}>
                  <ValidateButton
                    action={confirmAction}
                    disabled={!selectedBundle || !flightDate}
                    message={translations.confirm}
                  />
                </InputsWrapper>
              )
            }
          </Row>
        </Column>
      </ParkingWrapper>

        )}
      </MainWrapper>
    </Fragment>
  );
};

TicketInfo.propTypes = {
  ticketType: PropTypes.any,
  travelPurposes: PropTypes.any,
  shuttleDestinations: PropTypes.any,
  shuttleOrigins: PropTypes.any,
  quantityPersons: PropTypes.any,
  onChange: PropTypes.func,
  value: PropTypes.object,
  startDate: PropTypes.string,
  startTime: PropTypes.string,
  endDate: PropTypes.string,
  endTime: PropTypes.string,
  translations: PropTypes.object,
  locale: PropTypes.oneOf(['es', 'en']),
};

export default TicketInfo;
